import { PlacementOrderType } from 'app/models/Placement/PlacementDetails';
import { useSelector } from 'react-redux';
import { selectPlacementOrderType } from 'store/redux-store/placement-details/selectors';
import { selectBookingInfo } from 'store/redux-store/placement-summary/selectors';
import { useTranslation } from 'react-i18next';
import { useDecision } from '@optimizely/react-sdk';
import { ff_disable_travel_fields_when_arrived_for_strike } from 'app/constants/FeatureFlags/Global/keys';
import { selectUser } from 'oidc/user.selectors';
import { Authorized } from 'oidc/userHelper';
import { userRoles } from 'oidc/userRoles';

type ArrivedFieldsetGroup = 'travel' | 'eligibility';

const roleExceptions = {
  travel: [userRoles.recruitment_Leadership],
  eligibility: [userRoles.clinical_Director, userRoles.clinical_Manager],
} as const;

export function useArrivedFieldsetMeta(group: ArrivedFieldsetGroup = 'travel') {
  const { t } = useTranslation();
  const placementOrderType = useSelector(selectPlacementOrderType);
  const { confirmation: { arrived } } = useSelector(selectBookingInfo);
  const { userInfo } = useSelector(selectUser);
  const isStrike = placementOrderType === PlacementOrderType.StrikeOrderInHsg;
  const isArrived = !!arrived?.data?.checked;
  const [overrideStrikeFlag] = useDecision(ff_disable_travel_fields_when_arrived_for_strike);
  const isFeatureEnabled = overrideStrikeFlag.enabled === true;
  const hasRoleException = Authorized([...roleExceptions[group]], userInfo);

  const disabled = isStrike && isArrived && isFeatureEnabled && !hasRoleException;
  const title = disabled ? t('placement.profile.summary.offer.transportation.arrivedYesMessage') : undefined;
  return { disabled, title } as const;
}